import { createSlice } from "@reduxjs/toolkit";
import { ILocationTrials } from "packages/lib-utils";

// Define the TS type for the counter slice's state
export interface DataCollectionState {
  trials: ILocationTrials[] | null;
  locationSpecificDetails: any;
}

// Define the initial value for the slice state
const initialState: DataCollectionState = {
  trials: null,
  locationSpecificDetails: null,
};
export const DataCollectionSlice = createSlice({
  name: "DataCollection",
  initialState,
  reducers: {
    updateTrialsList: (state, action) => {
      state.trials = action.payload;
    },
    updateLocationInfo: (state, action) => {
      state.locationSpecificDetails = action.payload;
    },
  },
});

// Export the generated action creators for use in components
export const { updateTrialsList, updateLocationInfo } = DataCollectionSlice.actions;

// Export the slice reducer for use in the store configuration
export default DataCollectionSlice.reducer;
